/* eslint-disable @typescript-eslint/no-explicit-any */
import hasOwnProperty from './hasOwnProperty';

type StringMap = {
  [key: string]: any;
};
type DiffDesc = {
  toRemove: Array<string>;
  toAdd: Array<string>;
  toUpdate: Array<string>;
};

function diffByKey(oldItems: StringMap, newItems: StringMap): DiffDesc {
  let toRemove: Array<string> = [];
  let toAdd: Array<string> = [];
  let toUpdate: Array<string> = [];
  Object.keys(oldItems).forEach((key) => {
    if (hasOwnProperty(newItems, key)) {
      toUpdate.push(key);
    } else {
      toRemove.push(key);
    }
  });
  Object.keys(newItems).forEach((key) => {
    if (!hasOwnProperty(oldItems, key)) {
      toAdd.push(key);
    }
  });
  return { toRemove, toAdd, toUpdate };
}

export default diffByKey;
